import { PageLayout } from "../layout";
import React from "react";
import { observer } from "mobx-react";
import { ForgotPasswordForm } from "../../auth";

export const ForgotPasswordPage = observer(() => {
  return (
    <PageLayout>
      <ForgotPasswordForm />
    </PageLayout>
  );
});
